export default __webpack_public_path__ + "static/media/collection.38ccc2fc.png";